import { render, staticRenderFns } from "./EditCountryPage.vue?vue&type=template&id=2c15c733&scoped=true"
import script from "./EditCountryPage.vue?vue&type=script&lang=js"
export * from "./EditCountryPage.vue?vue&type=script&lang=js"
import style0 from "./EditCountryPage.vue?vue&type=style&index=0&id=2c15c733&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c15c733",
  null
  
)

export default component.exports